import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";

import { useAppDispatch, useAppSelector } from "../../redux/Store";
import { loggedInUserSelector, logout } from "../../redux/slice/LoggedInUserSlice";
import { StorageService, UtilService } from "../../services";

const SetLoggedInUser: React.FC = () => {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const { loggedInUser } = useAppSelector(loggedInUserSelector);

	const logoutOnUnauthorized = async () => {
		const _userDeviceToken: any = await StorageService.getUserDeviceToken();
		await StorageService.clearStorage();
		await StorageService.setUserDeviceToken(_userDeviceToken);
		dispatch(logout());
		await new Promise((r) => setTimeout(r, 500));
		navigate("/login", { replace: true });
	};

	useEffect(() => {
		UtilService.setLogoutOnUnauthorized(logoutOnUnauthorized);
	}, [loggedInUser]);

	return <Outlet />;
};

export default SetLoggedInUser;
